@if (!isFreeStyle) {
<div class="l-d-b cd-stepper">
  <div class="l-d-f l-fw-w" [ngClass]="[orientation === 'horizontal' ? 'step-wraper-horizontal' : 'l-fd-col step-wraper-vertical']">
    <ng-content></ng-content>
  </div>
</div>
} @if (isFreeStyle) {
<div>
  <ng-content select="[freeStyle]"></ng-content>
</div>
}
